var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "" } },
    [
      _c(
        "v-card",
        { staticClass: "rounded-card" },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c("h2", { staticClass: "h2_title mb-1" }, [
                _vm._v("\n        Información de Equipos\n      ")
              ]),
              _c("v-divider"),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md12: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm6: "",
                        md6: "",
                        lg4: "",
                        "mt-4": "",
                        "mb-5": ""
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Buscar...", "append-icon": "search" },
                        on: { input: _vm.handleSearch },
                        model: {
                          value: _vm.quickSearch,
                          callback: function($$v) {
                            _vm.quickSearch = $$v
                          },
                          expression: "quickSearch"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "" } },
                    [
                      _c("GridComponent", {
                        staticClass: "ag-theme-material",
                        attrs: { "grid-options": _vm.gridOptions }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }